/**
 * Partial `locale.aria` overrides for PrimeVue Paginator (rows-per-page Select, page links).
 * Keeps the rest of PrimeVue's default `locale` unchanged.
 */
const PAGINATOR_ARIA_EN = {
  pageLabel: 'Page {page}',
  firstPageLabel: 'First Page',
  lastPageLabel: 'Last Page',
  nextPageLabel: 'Next Page',
  prevPageLabel: 'Previous Page',
  rowsPerPageLabel: 'Rows per page',
};

const PAGINATOR_ARIA_DE = {
  pageLabel: 'Seite {page}',
  firstPageLabel: 'Erste Seite',
  lastPageLabel: 'Letzte Seite',
  nextPageLabel: 'Nächste Seite',
  prevPageLabel: 'Vorherige Seite',
  rowsPerPageLabel: 'Einträge pro Seite',
};

/** @param {object|undefined} config - `this.$primevue.config` from PrimeVue plugin */
export function applyPrimeVuePaginatorAria(config, locale) {
  if (!config?.locale?.aria) return;
  const patch = locale === 'de' ? PAGINATOR_ARIA_DE : PAGINATOR_ARIA_EN;
  Object.assign(config.locale.aria, patch);
}
